import { Component, Input, OnInit } from '@angular/core';
import { Select } from '@ngxs/store';
import { DetailsQueries } from '../../queries/details.queries';
import { Observable } from 'rxjs';
import { VehicleDetailsQuery } from '../../interfaces/vehicle-details.query';
import {LaunchDarklyService} from 'remarketing-angular-library';
import { TranslocoService, TranslocoDirective } from '@jsverse/transloco';
import { takeUntil } from 'rxjs/operators';
import { SaComponent } from 'smartauction-frontend-micro-library';
import { DatalistItemComponent } from 'remarketing-ui-components-lib';
import { NgClass, AsyncPipe, DecimalPipe } from '@angular/common';
import {
  MobilePhonePipe
} from '../../../../../profile-management/pipes/mobile-phone/mobile-phone.pipe';

@Component({
    selector: 'lib-vehicle-detail',
    templateUrl: './vehicle-detail.component.html',
    styleUrls: ['./vehicle-detail.component.scss'],
    imports: [TranslocoDirective, DatalistItemComponent, NgClass, AsyncPipe, DecimalPipe],
    providers: [MobilePhonePipe]
})
export class VehicleDetailComponent extends SaComponent implements OnInit {
  @Select(DetailsQueries.vehicleDetails) details$: Observable<VehicleDetailsQuery>;
  @Input() showHeading = true;

  vehicleDetailTranslations = {
    distanceUnit: ''
  }

  get isMsrpEnabled() {
    return this._launchDarklyService.getFeatureFlag('msrpEnabled', false);
  }

  constructor(
    private readonly _launchDarklyService: LaunchDarklyService,
    private readonly translocoService: TranslocoService
  ) {
    super();
  }

  ngOnInit(): void {
    this.getTranslations();
  }

  getTranslations() {

    const keyParams = {
      'common': {}
    };

    this.translocoService.selectTranslateObject(keyParams).pipe(takeUntil(this.destroyed$)).subscribe((translate: any[]) => {
      this.vehicleDetailTranslations.distanceUnit = translate[0].distanceUnit;
    }, error => {
      console.log(error);
    });
  }
}
